//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Builder.js";
import "../no/SketchOperationData.js";
import "../no/SketchConstraint.js";
import "../no/SketchFoundRelation.js";
let d=[[],[[["numRelations"],"FindRelations",{R_:{foundRelations:"SketchFoundRelation[]"}},0,0],[["relation","relax"],"SetRelationRelaxState",{},2,0],[[],"RestoreOperation",{},0,0],[["numStringSize"],"ExportSolverConfiguration",{R_:{configurationData:''}},0,1],[[],"ExportOperationData",{R_:{operationData:"SketchOperationData"}},0,0],[[],"GetSolverStatus",{R_:{solverStatus:''}},0,0],[["numConstraints"],"GetAppliedConstraints",{R_:{appliedConstraints:"SketchConstraint[]"}},0,0]],[]];
SPLM.SketchOperationBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.SketchOperationBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.SketchOperationBuilder.SolverStatus = Object.freeze({
    "Unknown" : "Unknown", "Initializing" : "Initializing", "Configured" : "Configured", "ConfigureFailed" : "ConfigureFailed", "Updated" : "Updated", "UpdateFailed" : "UpdateFailed"});

export default SPLM;